import React, {type FC} from 'react';
import {type RenderLeafProps} from 'slate-react';

import {type TextWithFormatting} from './types';
import * as S from './WBSlate.styles';

export const LeafNode: FC<RenderLeafProps & {leaf: TextWithFormatting}> = ({
  attributes,
  children,
  leaf,
}) => {
  const dataTest = leaf.inlineCode ? 'slate-inline-code-leaf' : 'slate-leaf';
  return (
    <S.Leaf
      strong={leaf.strong}
      emphasis={leaf.emphasis}
      inlineCode={leaf.inlineCode}
      underline={leaf.underline}
      delete={leaf.delete}
      codeComment={leaf.codeComment}
      operator={leaf.operator}
      url={leaf.url}
      keyword={leaf.keyword}
      variable={leaf.variable}
      regex={leaf.regex}
      number={leaf.number}
      boolean={leaf.boolean}
      tag={leaf.tag}
      constant={leaf.constant}
      symbol={leaf.symbol}
      attr={leaf.attr}
      selector={leaf.selector}
      punctuation={leaf.punctuation}
      string={leaf.string}
      char={leaf.char}
      function={leaf.function}
      isClass={leaf.class}
      onClick={leaf.onClick}
      data-test={dataTest}
      {...attributes}>
      {children}
    </S.Leaf>
  );
};
